// Rândul de deasupra listelor din profil (Programări, Recenzii, Finanțe): chip-ul cu numărul
// (TagUI, sticlă) și, în dreapta, sortarea (pastila de sticlă cu săgeata). Un singur loc, ca
// toate filele să aibă același rând.
import React from "react";
import { ReactSVG } from "react-svg";

import arrowIcon from "../../../assets/svg/arrow-s.svg";
import { TagUI } from "../../UI";
import { pressPoint } from "../../UI/glass";

/**
 * count · one / many: „1 recenzie” / „5 recenzii”
 * ascending + onToggleSort: sortarea (fără onToggleSort nu apare); sortLabels: [crescător, descrescător]
 */
export default function ProfileListMeta({ count = 0, one, many, ascending, onToggleSort, sortLabels = ["Sortează crescător", "Sortează descrescător"] }) {
   const label = ascending ? sortLabels[1] : sortLabels[0];
   return (
      <div className="studentsProfileUI__reservationsMeta">
         <TagUI size="md" className="studentsProfileUI__reservationsCount">
            {count} {count === 1 ? one : many}
         </TagUI>
         {typeof onToggleSort === "function" ? (
            <button type="button" onPointerDown={pressPoint} className="studentsProfileUI__sortBtn" onClick={onToggleSort} title={label} aria-label={label}>
               <ReactSVG src={arrowIcon} className={"studentsProfileUI__sortIcon" + (ascending ? "" : " is-desc")} />
            </button>
         ) : null}
      </div>
   );
}
